import React from "react";
import PropTypes from "prop-types";
import { FormattedMessage } from "react-intl";
import { Tag, TAG_SIZE } from "components/Tags";
import { TAG_COLORS } from "components/Tags/Tag";
import Tooltip from "components/Tooltip";
import { useAuth } from "hooks";
import { getFullName } from "utils";
import { USER_TYPES } from "constants/index";

const ApplicantLastTransitionActor = ({ actor }) => {
  const { isAdmin } = useAuth();

  if (!isAdmin || !actor?.name) return null;

  return (
    <Tooltip tooltipId="Missions.Applicants.LastTransitionActor.Tooltip" values={{ role: actor?.role }} hideIcon>
      <Tag size={TAG_SIZE.medium} {...getTagColorsForRole(actor?.role)}>
        <FormattedMessage
          id="Missions.Applicants.LastTransitionActor.Pill"
          values={{
            name: getFullName(actor, true),
          }}
        />
      </Tag>
    </Tooltip>
  );
};

const getTagColorsForRole = (role) => {
  switch (role) {
    case USER_TYPES.admin.toLowerCase():
      return TAG_COLORS.purple;
    case USER_TYPES.client.toLowerCase():
      return TAG_COLORS.pink;
    default:
      return TAG_COLORS.gray;
  }
};

ApplicantLastTransitionActor.propTypes = {
  actor: PropTypes.shape({
    name: PropTypes.string,
    firstName: PropTypes.string,
    lastName: PropTypes.string,
    role: PropTypes.string,
  }),
};

export default ApplicantLastTransitionActor;
